import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { ButtonComponent } from '@zero/shared/ui-web-design-system';

@Component({
  selector: 'tickets-faq-hint',
  templateUrl: './faq-hint.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoPipe, ButtonComponent],
})
export class FaqHintComponent {}
